/**
 * Panel Storage Namespace
 *
 * Every persistence key the package writes derives from one namespace so
 * applications never collide in shared localStorage. The namespace is set
 * once per document by `createPanelRegistry({ storageNamespace })` — at
 * module scope, BEFORE any store is created (stores are lazy singletons, so
 * their zustand `persist` keys resolve at first access, after the namespace
 * is already fixed).
 */

let storageNamespace = 'suite';
let namespaceLocked = false;

/** Lock the namespace in for this document. The first call wins; later
 * calls are ignored (one PanelShell per document — see the package README). */
export function setPanelStorageNamespace(namespace: string): void {
    if (namespaceLocked) return;
    if (!namespace) return;
    storageNamespace = namespace;
    namespaceLocked = true;
}

export function getPanelStorageNamespace(): string {
    return storageNamespace;
}

/** All package persistence keys funnel through here:
 * `<namespace>.<base>` (e.g. `hat.dock-layout`). */
export function panelStorageKey(base: string): string {
    return `${storageNamespace}.${base}`;
}
